


































import { Vue, Component } from 'vue-property-decorator';
import * as config from './config';
import { getRules, videoUrlList } from './api/index';
import SyPlayer from '@/components/SyPlayer.vue';
import { Popup } from 'vant';
Vue.use(Popup);
@Component({
  components: {
    SyPlayer,
  },
})
export default class Rules extends Vue {
  show: boolean = false;
  show2: boolean = false;
  show3: boolean = false;
  show4: boolean = false;
  show5: boolean = false;
  option = config.OPTHINES;
  Rules = '';
  videoUrl = '';
  async created() {
    const res = await getRules();
    this.Rules = res.data;
    const res2 = await videoUrlList();
    this.videoUrl = res2.data;
  }
  handleClickUpload(val: string) {
    this.$router.push({
      path: val,
    });
  }
  showPopup() {
    this.show = true;
  }
  showPopup2() {
    this.show2 = true;
  }
  showPopup3() {
    this.show3 = true;
  }
  showPopup4() {
    this.show4 = true;
  }
  showPopup5() {
    this.show5 = true;
  }
}
